// extracted by mini-css-extract-plugin
export default {"tagLabel":"tagLabel__zYQ9K","text":"text__Q0Fm5"};